import React from 'react'
import classnames from 'classnames'
import styles from './Tabs.module.scss'
import { TabsProps } from './types'
import classNames from 'classnames'

const Tabs = (props: TabsProps) => {

  const { tabs, navListClass = '', handleClick } = props
  const isLoading = tabs.findIndex((tab) => tab.isLoading === true)

  const listItemClass = (isActive, disabled) => classnames({
    [styles['nav-item']]: true,
    [styles['active']]: isActive,
    [styles['disabled']] : disabled
  })

  const click = (event, id) => {

    if (event.target.firstElementChild) {

      event.target.firstElementChild.click()

    }

    handleClick && handleClick(id)

  }

  return (
    <ul className={classNames(styles['nav-list'], navListClass)} data-bdd="nav-list">
      {tabs.map((item, index) => {

        const { disabled = false, id = null } = item

        if (item.shouldHide) {

          return null

        }

        return (
          <li
            key={index}
            className={listItemClass((item.isActive && isLoading === -1 || isLoading === index), disabled)}
            data-bdd={(item.dataBdd ? item.dataBdd : "") + "nav-item"}
            onClick={(event) => click(event, id)}
          >
            {item.tabItem}
          </li>
        )

      })}
    </ul>
  )

}

export default Tabs
